module.exports = __webpack_public_path__ + "img/my_archive.4f1b7cfc.svg";